<template>
	<div class="confirm-renewal">
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="$t('machineRenewal.title')"
			:visible.sync="dialogRenew"
			width="40%"
			top="9vh"
			@closed="closeDialog"
			@open="openDialog"
			:close-on-click-modal="false">
			<el-image
				style="width: 200px; height: 200px"
				:src="confirmRenew.img"
				:preview-src-list="srcList"
				fit="contain"></el-image>
			<el-form
				ref="confirmRenewal"
				:label-position="labelPosition"
				:model="renew"
				:rules="rules"
				label-width="80px">
				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item :label="$t('confirmRenewal.isRenew')">
							<el-select
								v-model="renew.state"
								:no-data-text="$t('common.noData')"
								:no-match-text="$t('common.noData')"
								:placeholder="$t('confirmRenewal.pIsRenew')">
								<el-option
									:label="$t('confirmRenewal.yes')"
									value="1"></el-option>
								<el-option
									:label="$t('confirmRenewal.no')"
									value="0"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item
							:label="$t('confirmRenewal.password')"
							prop="passWord"
							:error="error.passWord">
							<el-input
								type="password"
								v-model="renew.passWord"
								:placeholder="$t('confirmRenewal.pPassword')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item
							:label="$t('confirmRenewal.refuse')"
							v-if="renew.state == '0'"
							:prop="renew.state == '0' ? 'fail' : ''">
							<el-input
								type="textarea"
								:rows="4"
								v-model="renew.fail"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
				<el-button type="primary" @click="submitForm('confirmRenewal')">{{
					$t("common.definite")
				}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "ConfirmRenewal",
	props: {
		dialogRenew: Boolean,
		confirmRenew: Object,
	},
	data() {
		return {
			srcList: [],
			renew: {
				id: "",
				state: "0",
				fail: "",
				passWord: "",
			},
			labelPosition: "top",
			rules: {
				fail: [
					{
						required: true,
						message: this.$t("confirmRenewal.pRefuse"),
						trigger: "blur",
					},
				],
				passWord: [
					{
						required: true,
						message: this.$t("confirmRenewal.pPassword"),
						trigger: "blur",
					},
				],
			},
			error: {
				passWord: "",
			},
		};
	},
	methods: {
		closeDialog() {
			this.cancel("");
		},
		openDialog() {
			this.srcList = [];
			this.srcList.push(this.confirmRenew.img);
			this.renew.id = this.confirmRenew.id;
		},
		cancel(state) {
			this.$emit("cancel", false, state);
		},
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					let text = this.$t("renewalRecord.renewCf");
					if (this.renew.state == "0") {
						text = this.$t("renewalRecord.refuse");
					}
					this.$confirm(text, this.$t("common.tip"), {
						confirmButtonText: this.$t("common.definite"),
						cancelButtonText: this.$t("common.cancel"),
						type: "warning",
					}).then(() => {
						let obj = {};
						obj.id = this.confirmRenew.id;
						obj.state = this.renew.state;
						obj.fail = this.renew.fail;
						obj.passWord = this.$md5(this.renew.passWord);
						this.$api
							.request(this.$url.RenewalRecord.renew, this.$method.post, obj)
							.then(res => {
								if (res.code === 0) {
									this.$notify({
										title: this.$t("common.tip"),
										message: this.$t("renewalRecord.caozuoSuccess"),
										type: "success",
									});
									this.cancel("up");
								} else {
									this.$message.warning(res.msg);
								}
							});
					});
				}
			});
		},
	},
};
</script>

<style lang="scss">
.confirm-renewal {
	.el-image {
		display: block;
		margin: 0 auto 20px;
		border-radius: 4px;
	}
}
</style>
